import { useTranslation } from 'react-i18next';
import { Typography, Card, CardContent, Box, Divider } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Link } from '@mui/icons-material';

import { CaseResponseDto } from '@bandido/shared/dtos';
import {
  labelStyles,
  valueStyles,
  cardRootStyles,
  cardContentStyles,
  cardGridStyles,
  linkButtonStyles,
  dividerStyles,
} from '../styles';

interface CaseCardProps {
  caseData: CaseResponseDto;
  index: number;
  onCallLink: (caseId: CaseResponseDto['id']) => void;
  totalCases: number;
  isLoading: boolean;
}

export const CaseCard = ({ caseData, index, totalCases, onCallLink, isLoading }: CaseCardProps) => {
  const { t } = useTranslation();

  const renderCaseField = (label: string, value: string | number, isBold?: boolean) => (
    <>
      <Typography variant="body2" sx={labelStyles}>
        {label}:
      </Typography>
      <Typography variant="body2" sx={valueStyles(isBold)}>
        {typeof value === 'number' ? `#${value}` : value}
      </Typography>
    </>
  );

  const handleCallAssignment = () => onCallLink(caseData.id);

  return (
    <>
      <Card sx={cardRootStyles}>
        <CardContent sx={cardContentStyles}>
          <Typography variant="subtitle1">{caseData.name}</Typography>
          <Box sx={cardGridStyles}>
            {renderCaseField(t('calls.assignment.caseId'), caseData.id, true)}
            {renderCaseField(
              t('calls.assignment.client'),
              `${caseData.clientFirstName ?? ''} ${caseData.clientLastName ?? ''}`.trim() ||
                t('calls.assignment.clientUnassigned'),
            )}
            {renderCaseField(t('calls.assignment.flow'), caseData.workflowName)}
            {renderCaseField(t('calls.assignment.step'), caseData.stepName)}
            {renderCaseField(t('calls.assignment.status'), caseData.status)}
            {renderCaseField(t('calls.assignment.team'), caseData.teamName)}
            {renderCaseField(
              t('calls.assignment.assignedTo'),
              `${caseData.agentFirstName ?? ''} ${caseData.agentLastName ?? ''}`,
            )}
          </Box>
          <LoadingButton
            loading={isLoading}
            onClick={handleCallAssignment}
            variant="contained"
            color="secondary"
            size="small"
            fullWidth
            sx={linkButtonStyles}
            startIcon={<Link />}
          >
            {t('calls.assignment.link')}
          </LoadingButton>
        </CardContent>
      </Card>
      {index < totalCases - 1 && <Divider sx={{ my: 2, ...dividerStyles }} />}
    </>
  );
};
